<script>
  // Hero section for page headers
  export let title = '';
  export let subtitle = '';
  export let bgColor = 'bg-blue-50';
</script>

<div class="{bgColor} py-12">
  <div class="container mx-auto px-4 max-w-6xl text-center">
    <h1 class="text-3xl md:text-4xl font-bold mb-4">{title}</h1>
    {#if subtitle}
      <div class="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
        {subtitle}
      </div>
    {/if}
  </div>
</div>
